import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: undefined,
  },
  to: {
    type: [String, Object],
    default: undefined,
  },
  icon: {
    type: String,
    default: undefined,
  },
  tooltip: {
    type: String,
    default: undefined,
  },
  tooltipLeft: {
    type: String,
    default: undefined,
  },
  tooltipRight: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_c_tooltip = _resolveComponent("c-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    class: "c-icon-btn",
    flat: "",
    round: "",
    color: __props.color,
    to: __props.to,
    icon: __props.icon,
    "aria-label": __props.tooltip || __props.tooltipLeft || __props.tooltipRight
  }, {
    default: _withCtx(() => [
      (__props.tooltip)
        ? (_openBlock(), _createBlock(_component_c_tooltip, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltip), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.tooltipLeft)
        ? (_openBlock(), _createBlock(_component_c_tooltip, {
            key: 1,
            left: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltipLeft), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.tooltipRight)
        ? (_openBlock(), _createBlock(_component_c_tooltip, {
            key: 2,
            right: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.tooltipRight), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["color", "to", "icon", "aria-label"]))
}
}

})